import React from 'react';

import UserLootboxesApi from '../../../../Api/CRM/Modules/Lootbox/UserLootboxesApi';
import UserLootboxResponse from '../../../../Api/CRM/Responses/Lootbox/UserLootboxResponse';
import * as formatters from '../../../../utils/formatters';
import ProtectedLink from '../../../elements/ProtectedLink';
import Search from '../../../elements/Search';
import BooleanIcon from '../../../elements/booleanIcon';
import Card from '../../../elements/common/Card';
import FilterByColumn, { Filter } from '../../../elements/common/FilterByColumn';
import SortButton from '../../../elements/common/SortButton';
import { TableCell as Cell } from '../../../elements/common/TableDetailsRow';
import TableHead from '../../../elements/common/TableHead';
import TableLoader from '../../../elements/common/TableLoader';
import Paginator from '../../../elements/paginator';
import { PERMISSION } from '../../../helpers/Permissions';
import useAutoPaginator from '../../../hooks/useAutoPaginator';

function UserLootboxesPage() {
    const { items, isLoading, auto } = useAutoPaginator<UserLootboxResponse>((page, params) =>
        UserLootboxesApi.getAll(page, { params })
    );

    return (
        <Card title="All Lootbox tickets">
            <Search {...auto.search} />
            <FilterByColumn {...auto.filter}>
                <Filter column="created_at" label="Created at" type="dateRange" />
            </FilterByColumn>
            <TableLoader isLoading={isLoading}>
                <table className="table model-list">
                    <TableHead>
                        <th>Token</th>
                        <th>E-mail</th>
                        <th>Pool Item id</th>
                        <th>Reward id</th>
                        <th>Is open</th>
                        <th>Paid out</th>
                        <SortButton column="created_at" order="desc" {...auto.sort} />
                    </TableHead>
                    <TicketListTableBody tickets={items} />
                </table>
                <Paginator {...auto.paginator} />
            </TableLoader>
        </Card>
    );
}

function TicketListTableBody({ tickets }: { tickets: UserLootboxResponse[] }) {
    const { formatDateStringWithTimezone } = formatters;

    return (
        <tbody>
            {tickets.map((ticket) => (
                <tr key={ticket.id}>
                    <td>{ticket.token}</td>
                    <td key="email">
                        <ProtectedLink
                            url={`/users/${ticket.user_id}`}
                            value={ticket.email}
                            permissions={[PERMISSION.VIEW_USER]}
                        />
                    </td>
                    <td>{ticket.lootbox_pool_item_id}</td>
                    <td key="lootbox_item_id">
                        <ProtectedLink
                            url={`/lootbox_rewards/${ticket.lootbox_item_id}`}
                            value={ticket.lootbox_item_id}
                            permissions={[PERMISSION.VIEW_LOOTBOX]}
                        />
                    </td>
                    <td>
                        <BooleanIcon value={ticket.is_open} />
                    </td>
                    <td>
                        <BooleanIcon value={ticket.paid_out} />
                    </td>
                    <Cell>{formatDateStringWithTimezone(ticket.created_at)}</Cell>
                </tr>
            ))}
        </tbody>
    );
}

export default UserLootboxesPage;
